import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { TrackingIcons } from 'entities/device.map.stops/model/tracking-icons';
import { RenderWhenReady } from 'shared/components/render-when-ready';
import { useAction, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { async_select_tracking_gps_and_icons } from 'entities/device.map.track/lib/selectors';
import { showEventOnMap } from 'console/redux/main-actions';
import { useAPI } from 'console/shared/api/api-context';
export const DeviceStops = memo(function DeviceStops(props) {
    const { device_id, show_stops } = props;
    const api = useAPI();
    const gps_and_events = usePartialAppSelector(async_select_tracking_gps_and_icons, device_id, api);
    const onShowEventOnMap = useAction(showEventOnMap);
    if (!show_stops) {
        return null;
    }
    return (_jsx(RenderWhenReady, { promise: gps_and_events, loaderComponent: null, clear_on_promise_change: true, children: ([, events]) => (_jsx(TrackingIcons, { icons: events, onShowEventOnMap: onShowEventOnMap })) }));
});
